import { CheckCircle2, ExternalLink, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { StepProps } from "../types";

const ConnectStep = ({ data }: StepProps) => (
  <div className="space-y-6">
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="font-heading text-2xl font-semibold">Connect WhatsApp</h2>
        <Badge variant="outline" className="border-blue-300 bg-blue-50 text-blue-700">
          Meta only
        </Badge>
      </div>
      <p className="text-sm text-muted-foreground">
        WhatsApp connections are completed directly by the business owner through Meta Embedded Signup.
      </p>
    </div>

    <div className="flex items-start gap-3 rounded-lg border border-emerald-200 bg-emerald-50/70 p-4">
      <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-emerald-700" />
      <div className="space-y-1">
        <p className="text-sm font-medium text-emerald-950">Direct Meta connection</p>
        <p className="text-xs leading-relaxed text-emerald-900/80">
          Dibs uses Meta Cloud API and WhatsApp Coexistence. The owner can keep using the WhatsApp Business app while Dibs handles customer enquiries in parallel.
        </p>
      </div>
    </div>

    <div className="space-y-3 rounded-lg border bg-card p-4">
      <p className="text-sm font-medium">Ask the business owner to complete these steps</p>
      <ol className="space-y-3 text-sm text-muted-foreground">
        {[
          <>Sign in to the Dibs dashboard as <span className="font-medium text-foreground">{data.clientEmail}</span>.</>,
          <>Open <span className="font-medium text-foreground">Settings → Connectors → WhatsApp</span>.</>,
          <>Select <span className="font-medium text-foreground">Continue with Meta</span> and approve the requested business assets.</>,
        ].map((step, index) => (
          <li key={index} className="flex items-start gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary">
              {index + 1}
            </span>
            <span className="pt-0.5">{step}</span>
          </li>
        ))}
      </ol>
    </div>

    <div className="flex items-start gap-3 rounded-lg border p-4">
      <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
      <div>
        <p className="text-sm font-medium">No operator credentials required</p>
        <p className="mt-1 text-xs text-muted-foreground">
          The business owner authorises Meta directly. Dibs support never needs their Meta password or one-time code.
        </p>
      </div>
      <ExternalLink className="ml-auto h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
    </div>
  </div>
);

export default ConnectStep;
